/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const tpvPeriodEnum = {
	"24h": "24h",
	"7d": "7d",
	"30d": "30d",
	all: "all",
} as const;

export type TpvPeriodEnum = (typeof tpvPeriodEnum)[keyof typeof tpvPeriodEnum];

export type TpvPeriod = TpvPeriodEnum;
